import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';
import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import {
  ColumnMetadata,
  GenericTableAvlaComponent,
  GenericTableAvlaService,
  PipeTransformMetadata,
} from 'generic_table_avla_front_components';
import { map } from 'rxjs/operators';
import {
  AvlaGenericComponent,
  MessageService,
  UiDatepickerDirective,
} from 'shared-angular-components-avla';

@Component({
  selector: 'app-ml-table-state',
  templateUrl: './ml-table-state.component.html',
  styleUrls: ['./ml-table-state.component.css'],
  providers: [DatePipe, UiDatepickerDirective],
})
export class MlTableStateComponent
  extends AvlaGenericComponent
  implements OnInit
{
  @Input() statusData: any[] = [];

  @ViewChild('tablastatus') tablastatus: GenericTableAvlaComponent;

  statuscolumnas: ColumnMetadata[];
  primaryIndexerTable1: string[] = ['id'];
  opcionestado: any = [];
  dataStatus: any = [];

  constructor(
    protected datePipe: DatePipe,
    protected marklistservice: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService
  ) {
    super(restClientService, messageService, router, authService);
    this.statuscolumnas = [
      new ColumnMetadata('Fecha de registro', 'registerDate', '', true, true, [
        new PipeTransformMetadata(datePipe, ['dd/MM/yyyy']),
      ]),
      new ColumnMetadata('Fecha de Pago', 'paymentDate', '', true, true, [
        new PipeTransformMetadata(datePipe, ['dd/MM/yyyy']),
      ]),
      new ColumnMetadata(
        'Estado',
        { colName: 'estado', keyData: 'idStatus' },
        '',
        false,
        false
      ),
      new ColumnMetadata('Motivo', 'observation', '', true, true),
      new ColumnMetadata('Usuario', 'userNameRegister', '', true, true),
    ];
  }

  ngOnInit(): void {
    this.getopcionestado();
  }

  getopcionestado() {
    this.marklistservice.getStatusList(true).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        this.opcionestado = data;
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  getstatus(id: any) {
    const states = this.opcionestado
      .filter(s => s.idStatus === id)
      .map(t => t.nameStatus);
    return states[0] ? states[0] : null;
  }
}
